import React, { useRef } from "react";
import PropTypes from "prop-types";
import HeaderText from "./HeaderText";
import HeaderFilter from "./HeaderFilter";

/**
 * FedRamp Header
 * @param {Object} props
 * @param {boolean} props.isLoggedIn
 * @param {"All" | "Product" | "Provider"} props.searchFilter
 * @param {function} props.setSearchFilter
 * @param {string} props.searchText
 * @param {function} props.setSearchText
 * @param {Element | null} props.hoverModal
 * @param {boolean} props.blurred
 * @returns {Element}
 * @constructor
 */
export default function Header({
                                 isLoggedIn,
                                 searchFilter,
                                 setSearchFilter,
                                 searchText,
                                 setSearchText,
                                 hoverModal,
                                 blurred,
                               }) {
  const videoRef = useRef(null);

  return (<>
    <h1 className={`page_title${blurred ? " blurred" : ""}`}>FedRAMP</h1>
    <HeaderText blurred={blurred}/>
    <div className={`headerOptionsWrapper${blurred ? " blurred" : ""}`}>
      <div id="notesDiv">
        <p><strong>Notes:</strong></p>
        <ul>
          <li>To view Product details - select a Product name.</li>
          <li>To view Provider details - select a Provider name</li>
          <li>For a list of Agency Authorizations that have authorized a product as FedRAMP compliant on the SEWP
            contract - select the “Details” link.
          </li>
          {isLoggedIn && <li>
            <strong>For a list of Contract Holders that have indicated FedRAMP compliant products for a Provider -
              select a Contract Holder number.</strong>
          </li>}
          <li>To sort any column in ascending or descending order, select the up or down arrows next to the column
            heading.
          </li>
          {!isLoggedIn && <li>Government Customers may <a
            href="security/login/fedramp?from=/sewp5public/fedramp">Login</a> to view additional
            product details.</li>}
        </ul>
      </div>
      <HeaderFilter searchFilter={searchFilter} setSearchFilter={setSearchFilter} searchText={searchText}
                    setSearchText={setSearchText}/>
    </div>

    <div id="fedRampVideo">
      <a className="FEDRAMP" target="_blank"
         href="/documents/FEDRAMP.mp4" ref={videoRef}
         onClick={(event) => {
           event.preventDefault();
           videoPlayerHandler(videoRef.current);
         }}>
        <img src="/images/PLAY_50px.png" alt="PLAY"/>
        <br/>
        Watch our clip explaining FedRAMP!
      </a>
      {hoverModal}
    </div>
  </>);
}

Header.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  searchFilter: PropTypes.string.isRequired,
  setSearchFilter: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
  hoverModal: PropTypes.element,
  blurred: PropTypes.bool.isRequired,
};